import React from 'react';
import dayjs from 'dayjs';
// import QRCode from 'qrcode.react';
import InformationRow from '../../components/Agreement/InformationRow';

const Information = props => {
  const { information } = props;
  const { MemberName, MemberCode, Invoicenumber, Invoicedate } = information;
  
  return (
    <div className={'information'}>
      <p className={'title bold'}>课程协议书</p>
      {/* <div className={'qr-code-container'}>
        <InformationRow label={'防伪码'}>
          <QRCode value={'123'} renderAs={'svg'} />
        </InformationRow>
      </div> */}
      <div className={'details-container'}>
        <div className={'member-details'}>
          <InformationRow label={'会员名称'}>{MemberName}</InformationRow>
          <InformationRow label={'会员编号'}>{MemberCode}</InformationRow>
        </div>
        <div className={'agreement-details'}>
          <InformationRow label={'收据编号'}>{Invoicenumber}</InformationRow>
          <InformationRow label={'订单日期'}>{dayjs(Invoicedate).format('DD/MM/YYYY')}</InformationRow>
        </div>
      </div>
    </div>
  );
};

export default Information;